// Copyright 2020 Prescryptive Health, Inc.

import { DateTime } from 'luxon';

export const getNewDate = (): Date => {
  return DateTime.now().toJSDate();
};
